'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';
import uuid from "uuid";

export class NavbarComponent {
  menu = [{
    title: 'Home',
    state: 'main'
  }];

  isCollapsed = true;

  constructor(Auth,$http,$scope, dbFactory, db) {
    'ngInject';

    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
    this.$http = $http;
    this.$scope = $scope;
    this.dbFactory = dbFactory;
    this.db = db;

    console.log(this.isAdmin());
    var test = dbFactory.getCurrentUser()
    .then(response => {
      this.$scope.role = response.data[0].role;
      
    })
  }

  $onInit(){
    /**
     * API call to get user Organization info. Resolves promise synchronously from logged in user query, and then queries organization info. Pulled from Sql Server
     * param: Organization_ID (from logged in user)
     */
     if(this.db.getUser().length === 0){
      this.$http
      .get("/api/users/general")
      .then((response) => {
        console.log(response);
        this.$scope.user = response.data[0];
        this.$scope.role = this.$scope.user.role;
        this.$scope.city = response.data[0].Organization_Name;
        this.db.setUser(response.data[0]);
        console.log(this.$scope.city);
        
      })
      .catch((err) => {
        console.log(err);
      });
    } else {
      this.$scope.user = this.db.getUser();
      this.$scope.role = this.$scope.user.role;
      this.$scope.city = this.$scope.user.Organization_Name;
    
    }
  }

  submitFeedback() {
    console.log(this.$scope.feedback);
    this.spin = true;
    this.$scope.feedback.recid = uuid.v1();
    this.$http.post('/api/data/feedback', this.$scope.feedback)
        .then(response => {
            console.log(response);
            // this.$anchorScroll();
            this.feedbackSuccess = true;
            this.$scope.feedback = {};
            this.spin = false;
            $('#feedbackModal').modal('hide');

        })
        .catch(err => {
            console.log(err);
        })
}

}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js